

// import React, { useState } from 'react';
// import { Box, TextField, Button, Typography, Paper, InputAdornment, CircularProgress } from '@mui/material';
// import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
// import LoginIcon from '@mui/icons-material/Login';
// import { useNavigate } from 'react-router-dom';
// import toast, { Toaster } from 'react-hot-toast';
// import axios from 'axios';
// import { URL } from "../config";
// import LogoImg from '../assets/crmimg.png';

// const Login = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);

//   // States - डिझाइन न हलवता व्हॅल्यूज मॅनेज करण्यासाठी
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');

//   const handleLogin = async () => {
//     // Basic Validation
//     if (!username || !password) {
//       toast.error('Please enter Username and Password');
//       return;
//     }

//     setLoading(true);

//     try {
//       // बॅकएंडला आता आपण 'user_name' आणि 'password' पाठवणार आहोत
//       // तुमच्या कंट्रोलरमध्ये देखील हेच कीज (keys) वापरा
//       const response = await axios.post(`${URL}/employee-login`, {
//         username: username, // हा तुमच्या डेटाबेसमधील user_name कॉलमसाठी आहे
//         password: password, // हा तुमच्या डेटाबेसमधील password कॉलमसाठी आहे
//       });

//       if (response.data && response.data.status === 'success') {
//         const userData = response.data.user;

//         // Local Storage मध्ये डेटा सेव्ह करा
//         localStorage.setItem('user_data', JSON.stringify({
//           userid: userData.id,
//           username: userData.name,
//           role: userData.role 
//         }));

//         toast.success('Login successful!', {
//           duration: 3000,
//           position: 'top-right',
//           style: { background: '#2ecc71', color: '#fff', fontWeight: 'bold' },
//         });

//         setTimeout(() => {
//           setLoading(false);
//           navigate('/dashboard'); 
//         }, 1500);
//       }
//     } catch (error) {
//       setLoading(false);
//       // चुकीचा युजरनेम किंवा पासवर्ड असल्यास एरर दाखवा
//       const errorMsg = error.response?.data?.error?.message || 'Invalid Username or Password!';
//       toast.error(errorMsg);
//     }
//   };

//   return (
//     <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f4f7fa', p: { xs: 2, md: 0 } }}>
//       <Toaster />

//       {loading && (
//         <Box sx={{
//           position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
//           bgcolor: 'rgba(255, 255, 255, 0.8)',
//           display: 'flex', justifyContent: 'center', alignItems: 'center',
//           zIndex: 9999, backdropFilter: 'blur(3px)'
//         }}>
//           <CircularProgress size={60} sx={{ color: '#ff0000' }} /> 
//         </Box>
//       )}

//       <Paper elevation={10} sx={{
//         width: '100%', maxWidth: 950, borderRadius: '20px', overflow: 'hidden',
//         display: 'flex', flexDirection: { xs: 'column', md: 'row' }, minHeight: { md: '550px' }
//       }}>

//         {/* डावी बाजू - Logo (No Change) */}
//         <Box sx={{ flex: 1, bgcolor: '#ffffff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 4, borderRight: { md: '1px solid #f0f0f0' } }}>
//           <img src={LogoImg} alt="Logo" style={{ width: '100%', maxWidth: '280px', height: 'auto' }} />
//           <Typography variant="h6" sx={{ mt: 3, fontWeight: 700, color: '#333', textAlign: 'center' }}>
//             वरदविनायक रिअल इन्फ्रा प्रा. लि.
//           </Typography>
//         </Box>

//         {/* उजवी बाजू - Form (Logic Updated) */}
//         <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', p: { xs: 4, md: 6 }, bgcolor: '#ffffff' }}>
//           <Typography variant="h4" sx={{ fontWeight: 800, color: '#e65100', mb: 1 }}>Welcome Back!</Typography>
//           <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>Welcome, Login to Your Account.</Typography>

//           <TextField
//             fullWidth
//             placeholder="User Name"
//             margin="normal"
//             value={username}
//             onChange={(e) => setUsername(e.target.value)}
//             slotProps={{
//               input: {
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <PersonOutlineOutlinedIcon sx={{ color: '#9e9e9e' }} />
//                   </InputAdornment>
//                 ),
//                 sx: {
//                   borderRadius: '12px',
//                   backgroundColor: '#ffffff',
//                   "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ced4da" },
//                   "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#e65100" },
//                   "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#e65100", borderWidth: "2px" }
//                 }
//               }
//             }}
//           />

//           <TextField
//             fullWidth
//             placeholder="Password"
//             type="password"
//             margin="normal"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             slotProps={{
//               input: {
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <LockOutlinedIcon sx={{ color: '#9e9e9e' }} />
//                   </InputAdornment>
//                 ),
//                 sx: {
//                   borderRadius: '12px',
//                   backgroundColor: '#ffffff',
//                   "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ced4da" },
//                   "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#e65100" },
//                   "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#e65100", borderWidth: "2px" }
//                 }
//               }
//             }}
//           />

//           <Button
//             fullWidth variant="contained"
//             onClick={handleLogin}
//             startIcon={<LoginIcon />}
//             disabled={loading}
//             sx={{
//               mt: 4, py: 1.5, borderRadius: '25px', bgcolor: '#e65100',
//               textTransform: 'none', fontSize: '1rem', fontWeight: 600,
//               '&:hover': { bgcolor: '#d50000' }
//             }}
//           >
//             {loading ? 'Logging in...' : 'Login'}
//           </Button>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default Login;  

import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, InputAdornment, CircularProgress } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LoginIcon from '@mui/icons-material/Login';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { URL } from "../config";
import LogoImg from '../assets/crmimg.png';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    if (!username || !password) {
      toast.error('Please enter Username and Password');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${URL}/employee-login`, {
        username: username,
        password: password,
      });

      if (response.data && response.data.status === 'success') {
        const userData = response.data.user;

        localStorage.setItem('user_data', JSON.stringify({
          userid: userData.id,
          username: userData.name,
          role: userData.role
        }));

        toast.success('Login successful!', {
          duration: 3000,
          position: 'top-right',
          style: { background: '#2ecc71', color: '#fff', fontWeight: 'bold' },
        });

        setTimeout(() => {
          setLoading(false);
          navigate('/dashboard');
        }, 1500);
      }
    } catch (error) {
      setLoading(false);
      const errorMsg = error.response?.data?.error?.message || 'Invalid Username or Password!';
      toast.error(errorMsg);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f4f7fa', p: { xs: 2, md: 0 } }}>
      <Toaster />

      {loading && (
        <Box sx={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          bgcolor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          zIndex: 9999, backdropFilter: 'blur(3px)'
        }}>
          <CircularProgress size={60} sx={{ color: '#ff0000' }} />
        </Box>
      )}

      <Paper elevation={10} sx={{
        width: '100%', maxWidth: 950, borderRadius: '20px', overflow: 'hidden',
        display: 'flex', flexDirection: 'column', minHeight: { md: '550px' }
      }}>

        {/* दोन्ही boxes एका row मध्ये */}
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, flex: 1 }}>

          {/* डावी बाजू - Logo */}
          <Box sx={{
            flex: 1, bgcolor: '#ffffff', display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', p: 4,
            borderRight: { md: '1px solid #f0f0f0' }
          }}>
            <img src={LogoImg} alt="Logo" style={{ width: '100%', maxWidth: '280px', height: 'auto' }} />

            <Typography variant="h6" sx={{ mt: 3, fontWeight: 700, color: '#333', textAlign: 'center' }}>
              वरदविनायक रिअल इन्फ्रा प्रा. लि.
            </Typography>
          </Box>

          {/* उजवी बाजू - Form */}
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', p: { xs: 4, md: 6 }, bgcolor: '#ffffff' }}>
            <Typography variant="h4" sx={{ fontWeight: 800, color: '#e65100', mb: 1 }}>Welcome Back!</Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>Welcome, Login to Your Account.</Typography>

            <TextField
              fullWidth
              placeholder="User Name"
              margin="normal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutlineOutlinedIcon sx={{ color: '#9e9e9e' }} />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: '12px',
                    backgroundColor: '#ffffff',
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ced4da" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#e65100" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#e65100", borderWidth: "2px" }
                  }
                }
              }}
            />

            <TextField
              fullWidth
              placeholder="Password"
              type="password"
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockOutlinedIcon sx={{ color: '#9e9e9e' }} />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: '12px',
                    backgroundColor: '#ffffff',
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#ced4da" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#e65100" },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#e65100", borderWidth: "2px" }
                  }
                }
              }}
            />

            <Button
              fullWidth variant="contained"
              onClick={handleLogin}
              startIcon={<LoginIcon />}
              disabled={loading}
              sx={{
                mt: 4, py: 1.5, borderRadius: '25px', bgcolor: '#e65100',
                textTransform: 'none', fontSize: '1rem', fontWeight: 600,
                '&:hover': { bgcolor: '#d50000' }
              }}
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </Box>

        </Box>

        {/* ✅ COMTRANSE TECHNOLOGY branding - दोन्ही boxes च्या खाली, Paper च्या आत, center ला */}
        <Box sx={{
          width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center',
          py: 1.5, borderTop: '1px solid #f0f0f0', bgcolor: '#ffffff'
        }}>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 800,
              textTransform: 'uppercase',
              letterSpacing: '1px',
              fontSize: '0.85rem',
              textAlign: 'center',
              px: 1,
            }}
          >
            <span style={{ color: '#E91E63' }}>COM</span>
            <span style={{ color: '#03A9F4' }}>TRANSE</span>
            <span style={{ color: '#1E293B', marginLeft: '4px' }}>TECHNOLOGY PVT.LTD.KOLHAPUR</span>
          </Typography>
        </Box>

      </Paper>

    </Box>
  );
};

export default Login;